<template>
  <div class="cook-dashboard space-y-4">
    <!-- Header -->
    <div class="bg-gradient-to-br from-red-500 to-red-600 rounded-xl p-6 text-white shadow-lg">
      <h2 class="text-xl font-bold mb-2">👨‍🍳 Cuisine Centrale</h2>
      <p class="text-sm opacity-90">Statistiques & Retours</p>
    </div>

    <!-- Top 3 -->
    <div class="bg-white rounded-xl p-4 shadow-sm">
      <h3 class="font-bold text-gray-800 mb-3 flex items-center gap-2">🏆 TOP 3 DE LA SEMAINE</h3>
      <div class="space-y-3">
        <div v-for="(recipe, idx) in topRecipes" :key="idx" class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <span class="text-2xl font-bold text-gray-400">{{ idx + 1 }}.</span>
            <span class="font-semibold">{{ recipe.name }}</span>
          </div>
          <span class="flex items-center gap-2 text-green-600 font-bold">😊 {{ recipe.rating }}%</span>
        </div>
      </div>
    </div>

    <!-- À améliorer -->
    <div class="bg-white rounded-xl p-4 shadow-sm border-2 border-orange-200">
      <h3 class="font-bold text-gray-800 mb-3 flex items-center gap-2">⚠️ À AMÉLIORER</h3>
      <div class="space-y-4">
        <div v-for="(recipe, idx) in toImprove" :key="idx" class="bg-orange-50 rounded-lg p-3">
          <div class="flex items-start justify-between mb-2">
            <div>
              <span class="font-semibold text-gray-800">{{ idx + 1 }}. {{ recipe.name }}</span>
              <div class="flex items-center gap-2 mt-1">
                <span class="text-orange-600 font-bold">😐 {{ recipe.rating }}%</span>
              </div>
            </div>
          </div>
          <p class="text-sm text-gray-600 mb-2">💬 {{ recipe.feedback }} ({{ recipe.comments }} écoles)</p>
          <button @click="viewDetails(recipe)" class="text-blue-600 text-sm font-medium hover:underline">
            📊 Voir détails
          </button>
        </div>
      </div>
    </div>

    <!-- Planification -->
    <div class="bg-white rounded-xl p-4 shadow-sm">
      <h3 class="font-bold text-gray-800 mb-3">🗓️ PLANIFICATION</h3>
      <div class="bg-blue-50 rounded-lg p-4">
        <p class="font-semibold text-gray-800 mb-2">Jeudi 8 janvier</p>
        <p class="text-sm text-gray-600 mb-1">
          Menu prévu :
          <span class="font-semibold">Hachis parmentier</span>
        </p>
        <p class="text-sm text-gray-600 mb-2">
          Historique :
          <span class="text-green-600 font-bold">😊 78%</span>
        </p>
        <button @click="viewPreviousRemarks" class="text-blue-600 text-sm font-medium hover:underline">
          Remarques précédentes (4)
        </button>
      </div>
    </div>

    <!-- Toutes les statistiques -->
    <button
      @click="showAllStats"
      class="w-full bg-purple-500 hover:bg-purple-600 text-white rounded-lg p-4 font-semibold shadow-md transition"
    >
      📋 Toutes les statistiques
    </button>
  </div>
</template>

<script>
export default {
  name: "CookDashboard",
  data() {
    return {
      topRecipes: [
        { name: "Lasagnes bolognaise", rating: 92 },
        { name: "Couscous poulet", rating: 87 },
        { name: "Gratin dauphinois", rating: 85 },
      ],
      toImprove: [
        {
          name: "Poisson pané",
          rating: 58,
          comments: 12,
          feedback: '"Trop sec"',
        },
        {
          name: "Purée de légumes",
          rating: 61,
          comments: 8,
          feedback: '"Texture"',
        },
      ],
    }
  },
  methods: {
    viewDetails(recipe) {
      alert(`Détails pour : ${recipe.name}`)
    },
    viewPreviousRemarks() {
      alert("Affichage des remarques précédentes")
    },
    showAllStats() {
      alert("Affichage de toutes les statistiques")
    },
  },
}
</script>

<style scoped>
.space-y-4 > * + * {
  margin-top: 1rem;
}
.space-y-3 > * + * {
  margin-top: 0.75rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.flex {
  display: flex;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.justify-between {
  justify-content: space-between;
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.from-red-500 {
  --tw-gradient-from: #ef4444;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-red-600 {
  --tw-gradient-to: #dc2626;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.shadow-sm {
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}
.shadow-md {
  box-shadow: 0 2px 4px -2px rgb(0 0 0 / 0.1);
}
.shadow-lg {
  box-shadow: 0 4px 6px -4px rgb(0 0 0 / 0.1);
}
.border-2 {
  border-width: 2px;
}
.border-orange-200 {
  border-color: #fed7aa;
}
.bg-white {
  background-color: #ffffff;
}
.bg-blue-50 {
  background-color: #eff6ff;
}
.bg-orange-50 {
  background-color: #fff7ed;
}
.bg-purple-500 {
  background-color: #a855f7;
}
.bg-purple-600 {
  background-color: #9333ea;
}
.hover\:bg-purple-600:hover {
  background-color: #9333ea;
}
.text-white {
  color: #ffffff;
}
.text-orange-600 {
  color: #ea580c;
}
.text-green-600 {
  color: #16a34a;
}
.text-blue-600 {
  color: #2563eb;
}
.text-gray-400 {
  color: #9ca3af;
}
.text-gray-600 {
  color: #4b5563;
}
.text-gray-800 {
  color: #1f2937;
}
.font-bold {
  font-weight: 700;
}
.font-semibold {
  font-weight: 600;
}
.font-medium {
  font-weight: 500;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-6 {
  padding: 1.5rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.w-full {
  width: 100%;
}
.opacity-90 {
  opacity: 0.9;
}
.transition {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.hover\:underline:hover {
  text-decoration: underline;
}
button {
  cursor: pointer;
  border: none;
  background: none;
}
button:hover {
  opacity: 0.9;
}
</style>
